import React from "react";
import { Link, NavLink } from "react-router-dom";

const UserDashTab = (props) => {
  const { tabs, activeTab, handleTabClick } = props;
  const renderTabs = () => {
    return tabs.map((tab, index) => (
      <Link className={activeTab === index ? "active" : ""}>
        <div
          onClick={() => {
            handleTabClick(index);
          }}
        >
          {tab.title}
        </div>
      </Link>
    ));
  };
  return (
    <div className="col-lg-4">
      <div className="services-list">
        {renderTabs()} <Link to={"/"}>Logout</Link>
      </div>
    </div>
  );
};

export default UserDashTab;
